import { IPaginatedRequest } from '@cbgms/api/request'
import * as types from './types'
import { InvoiceExportListResponse } from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const loadExportedInvoices = (params: IPaginatedRequest) => {
  return AsyncAction<InvoiceExportListResponse>({
    type: [types.LOAD_EXPORTED_INVOICES, types.LOAD_EXPORTED_INVOICES_SUCCESS, types.LOAD_EXPORTED_INVOICES_FAILED],
    payload: {
      api: 'support',
      request: {
        method: 'GET',
        url: '/modules/accountancy/export',
        params
      }
    }
  })
}
